import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IQdsRequest, IQdsSignature } from "../../entities/IQdsRequest";
import { IDocument } from "../../entities/IDocument";

export interface QdsRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface QdsSignature {
  id: number;
  pageIndex: number;
  rect: QdsRect;
  dataUrl: string;
}

export interface IQdsDocumentData {
  qdsRequest?: IQdsRequest;
  qdsSignature?: IQdsSignature;
  document?: IDocument;
}

interface QdsDocumentsState {
  qdsSignatures: QdsSignature[];
  isQdsSigning: boolean;
  qdsDocumentIsSuccessfullySigned: boolean;
  fetchedQdsDocument?: IQdsDocumentData;
  qdsSplitPages?: string[];
  qdsDocumentBlobUrl?: string;
}

const initialState: QdsDocumentsState = {
  qdsSignatures: [],
  isQdsSigning: false,
  qdsDocumentIsSuccessfullySigned: false,
};

export const qdsDocumentsSlice = createSlice({
  name: "qdsDocuments",
  initialState,
  reducers: {
    addQdsSignature: (state, action: PayloadAction<QdsSignature>) => {
      state.qdsSignatures.push(action.payload);
    },
    removeQdsSignature: (state, action: PayloadAction<number>) => {
      state.qdsSignatures = state.qdsSignatures.filter((sig) => sig.id !== action.payload);
    },
    clearQdsSignatures: (state) => {
      state.qdsSignatures = [];
    },
    setFetchedQdsDocument: (state, action: PayloadAction<IQdsDocumentData>) => {
      state.fetchedQdsDocument = action.payload;
    },
    setIsQdsSigning: (state, action: PayloadAction<boolean>) => {
      state.isQdsSigning = action.payload;
    },
    setQdsSplitPages: (state, action: PayloadAction<string[]>) => {
      state.qdsSplitPages = action.payload;
    },
    setQdsDocumentSuccessfullySignedStatus: (state, action: PayloadAction<boolean>) => {
      state.qdsDocumentIsSuccessfullySigned = action.payload;
    },
    setQdsDocumentBlobUrl: (state, action: PayloadAction<string>) => {
      state.qdsDocumentBlobUrl = action.payload;
    },
  },
});

export const qdsDocumentsActions = qdsDocumentsSlice.actions;

export default qdsDocumentsSlice.reducer;
